import { render, staticRenderFns } from "./Editnews.vue?vue&type=template&id=4bb7a9cf&scoped=true&"
import script from "./Editnews.vue?vue&type=script&lang=js&"
export * from "./Editnews.vue?vue&type=script&lang=js&"
import style0 from "./Editnews.vue?vue&type=style&index=0&id=4bb7a9cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7a9cf",
  null
  
)

export default component.exports